import Swal from "sweetalert2";

export function buildStrategyConflictHtml(blockingStrategies) {
  if (!blockingStrategies?.length) return "";
  return blockingStrategies
    .map((b) => {
      const pairs = (b.overlappingPairs || [])
        .map((p) => `<code>${p.exchange}</code> · <code>${p.symbol}</code>`)
        .join(", ");
      return `<p style="margin:8px 0"><strong>${b.fullName}</strong> <span style="opacity:.8">(${
        b.bot || "—"
      })</span><br/>${pairs}</p>`;
    })
    .join("");
}

export function alertStrategyConflictSaved({ blockingStrategies, isCreate }) {
  const title = isCreate
    ? "Estrategia creada en inactivo"
    : "Cambios guardados; estrategia en inactivo";
  const intro =
    "Hay otra estrategia activa con el mismo par (exchange + moneda):";
  return Swal.fire({
    icon: "warning",
    title,
    html: `<div style="text-align:left;font-size:14px"><p>${intro}</p>${buildStrategyConflictHtml(
      blockingStrategies,
    )}</div>`,
    width: 560,
  });
}

export function alertStrategyConflictActivate(blockingStrategies) {
  return Swal.fire({
    icon: "warning",
    title: "No se puede activar",
    html: `<div style="text-align:left;font-size:14px"><p>Desactiva la otra estrategia o cambia las monedas:</p>${buildStrategyConflictHtml(
      blockingStrategies,
    )}</div>`,
    width: 560,
  });
}
